export const FIRST_BLOOD_BOUNTY = 400;
/** Anti-snowball (SPY-108): flatter kill curve, hard cap below classic 500. */
export const MAX_KILL_BOUNTY = 450;
export const KILL_STREAK_BOUNTY = [300, 325, 365, 410, 450];
/** Softer death-streak floor (75g) to limit feeder-farm extremes. */
export const DEATH_STREAK_BOUNTY = [300, 220, 160, 120, 90, 75];

export function calculateKillBounty(killStreak, deathStreak, isFirstBlood) {
  if (isFirstBlood) return FIRST_BLOOD_BOUNTY;

  let gold = 300;
  if (killStreak > 0) {
    const idx = Math.min(KILL_STREAK_BOUNTY.length - 1, killStreak);
    gold = KILL_STREAK_BOUNTY[idx];
  } else if (deathStreak > 0) {
    const idx = Math.min(DEATH_STREAK_BOUNTY.length - 1, deathStreak);
    gold = DEATH_STREAK_BOUNTY[idx];
  }

  return Math.min(gold, MAX_KILL_BOUNTY);
}

export function calculateDeathTimer(level, gameTimeInSec) {
  const base = 7.5;
  const levelMult = level * 2.5;
  const timeBonus = (gameTimeInSec / 60) * 0.6;
  return Math.round(base + levelMult + timeBonus);
}
